import React from "react";
import PropTypes from "prop-types";
import "./member-icon.scss";

const MemberIcon = ({ type, member, extraMembers, typeColor }) => {
  let initials = '';
  let memberName = member.userNameFull || member.Name;

  if (member && memberName) {
    const names = memberName.split(" ").slice(0, 2); // Limit to the first two names
    initials = names.map(name => name[0]?.toUpperCase()).join('');
  }

  let className = "";
  if (type === "user") {
    className = "-user";
  } else if (type === "extra") {
    className = "-extra";
    if (extraMembers > 98) {
      initials = '99+';
    } else {
      initials = `+${extraMembers}`;
    }
  }

  return (
    member && memberName &&
    <React.Fragment key={memberName}>
      <div className={`member-icon${className} d-flex align-items-center`} style={{ backgroundColor: typeColor || "" }}>
        <div className={`member-icon-initials${className}`}>{initials}</div>
      </div>
    </React.Fragment>
  );
};

MemberIcon.propTypes = {
  type: PropTypes.oneOf(['user', 'extra']).isRequired,
  member: PropTypes.shape({
    Name: PropTypes.string,
    userNameFull: PropTypes.string,
  }),
  extraMembers: PropTypes.number,
  typeColor: PropTypes.string,
};

MemberIcon.defaultProps = {
  member: null,
  extraMembers: 0,
};

export default MemberIcon;
